/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import userAccountsApi from '../../../../api/user.api';
import { createFOAsyncThunk } from '../../../helpers/thunk.helpers';
import { keycloakService } from '../../auth/auth.service';
import { RoutePath } from '../../../../shared/enums/RoutePath';
import { handleRedirectAndReload } from '../../../../shared/utils/routingUtils';

/* Thunks */
export const getUserThunk = createFOAsyncThunk('user/getUser', async userId => userAccountsApi.getUser(userId));

export const postSwitchOrganizationThunk = createFOAsyncThunk('user/changeOrganization', async (organizationId) => {
  await userAccountsApi.switchOrganization(organizationId);
  const changed = await keycloakService.refreshToken({ force: true });
  if (changed) {
    handleRedirectAndReload(RoutePath.generateRoutePath(RoutePath.DASHBOARD, {}), true);
  }
  return changed;
});
